import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=2cffbee0&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&id=2cffbee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffbee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
